import { FormProvider, useForm } from 'react-hook-form';
import { Outlet } from 'react-router';
import { getMaterialTypes, Product, Shape } from '@steelbuy/ts-shared';
import { SuccessErrorNotificationContextProvider, WizardStepsContextProvider } from '@steelbuy/ui-primitive';
import { useIsVendorFeatureSupported } from '@steelbuy/vendor';
import { BulkListingContextProvider } from '../../components/bulk-listing/bulk-listing-context/BulkListingContext';
import { BULK_LISTING_STEPS } from '../../components/bulk-listing/bulkListingUtil';

export const BulkListingView = () => {
    const isQualityCategoriesSupported = useIsVendorFeatureSupported('NON_PRIME_CATEGORIES');
    const methods = useForm({
        defaultValues: {
            autoRenew: true,
            materialType: getMaterialTypes()[0],
            shape: Shape.FLAT,
            product: Product.COIL,
            prime: isQualityCategoriesSupported ? undefined : true,
        },
    });
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(() => {})}>
                <BulkListingContextProvider>
                    <SuccessErrorNotificationContextProvider>
                        <WizardStepsContextProvider steps={BULK_LISTING_STEPS}>
                            <Outlet />
                        </WizardStepsContextProvider>
                    </SuccessErrorNotificationContextProvider>
                </BulkListingContextProvider>
            </form>
        </FormProvider>
    );
};
